import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestRestoreStaffManager } from "./restoreStaffManager.request";

const useRestoreStaffManager = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchStaffManagers = useRefetchQuery(["staff"]);

  return useMutation({
    mutationFn: requestRestoreStaffManager,
    ...options,
    onSuccess: (...args) => {
      refetchStaffManagers();
      options?.onSuccess?.(...args);
    }
  });
};

export default useRestoreStaffManager;
